/**
 * multiply two quaternions together - order [w, x, y, z]
 */
export function quaternionMultiply(left, right) {
    // have some maths: https://www.mathworks.com/help/aeroblks/quaternionmultiplication.html
    const [r0, r1, r2, r3] = right;
    const [q0, q1, q2, q3] = left;
    const nw = r0 * q0 - r1 * q1 - r2 * q2 - r3 * q3;
    const nx = r0 * q1 + r1 * q0 - r2 * q3 + r3 * q2;
    const ny = r0 * q2 + r1 * q3 + r2 * q0 - r3 * q1;
    const nz = r0 * q3 - r1 * q2 + r2 * q1 + r3 * q0;
    return [nw, nx, ny, nz];
}
//# sourceMappingURL=quaternionMultiply.js.map